import React, { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Label,
} from "@/components/ui";
import { Building } from "lucide-react";
import financeService from "@/services/financeService";

/**
 * Subsidiary Filter Component
 *
 * Allows selection of individual subsidiaries or consolidated view.
 * The report endpoints validate subsidiary_id as a real integer (Subsidiary.id),
 * so this fetches the actual subsidiary list rather than a hardcoded one.
 * Requirements: 2.1-2.5
 */
const SubsidiaryFilter = ({ value, onChange, subsidiaries = [] }) => {
  const [fetchedSubsidiaries, setFetchedSubsidiaries] = useState([]);

  useEffect(() => {
    if (subsidiaries.length > 0) return;
    financeService
      .getSubsidiaries()
      .then((response) => {
        setFetchedSubsidiaries(response?.data?.data?.subsidiaries || []);
      })
      .catch(() => setFetchedSubsidiaries([]));
  }, [subsidiaries.length]);

  const subsidiaryList = [
    { id: null, name: "Consolidated (All Subsidiaries)" },
    ...(subsidiaries.length > 0 ? subsidiaries : fetchedSubsidiaries),
  ];

  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2">
        <Building className="h-4 w-4" />
        Subsidiary
      </Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select subsidiary" />
        </SelectTrigger>
        <SelectContent>
          {subsidiaryList.map((sub) => (
            <SelectItem key={sub.id || "all"} value={sub.id || ""}>
              {sub.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SubsidiaryFilter;
